//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.DialogsAdeProcesRealizaceKniha.ts						</Name>
//    <Description> Funkce pro otev�en� dialog� spojen�ch s Vazba procesu realizace na knihu </Description>
//    <Author>      JKLUSACEK													</Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-12-02                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.38.1
//AdtGeneratorConfig:[ T:(srvvprk) GID:(Web.Dia.Ts) V1:(ixs_prr,ixs_pla,aktivita,dat_zmena,zmenu_prov) V2:() K1:() K2:() K3:() ]

namespace Gordic.Adm.Dialogs {

    // AdeProcesRealizaceKniha
    export function DetailAdeProcesRealizaceKnihaDlg(
        parentContent: GContent,
        opt: {
            /** ixs_prr */
            ixs_prr: string | null,
            /** ixs_pla */
            ixs_pla: string | null,
            /** grid jquery element */
            grid?: JQuery<HTMLElement>,
            /** p��znak nov�ho z�znamu */
            newRecord?: boolean
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

    const deferred = $.Deferred();
    const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
    ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

    let isValid = true;
    var detailCommand = opt.grid ? false : true;

    // grid remote control, kv�li �ipk�m na detailu
    const gridRemoteControl = opt && opt.grid ? new Gordic.Components.GridRC(opt.grid) : undefined;

    var detail = ['Gordic.Adm.WebControls.DetailAdeProcesRealizaceKniha', { gridRemoteControl: gridRemoteControl }]

    const options = {
        ID: "AdmAdeProcesRealizaceKniha#",
        ixs_prr: opt ? opt.ixs_prr : undefined,
        ixs_pla: opt ? opt.ixs_pla : undefined,
        newRecord: opt ? opt.newRecord : undefined,
        detailCommand: detailCommand
    };

    if (isValid) {
        //RC 32131033 : Detail
        Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
    } else {
        deferred.reject();
    }
    return deferred.promise();
}

    // AdeProcesRealizaceKniha
    export function SeznamAdeProcesRealizaceKnihaDlg(
        parentContent: GContent,
        opt: {
            /** ixs_prr */
            ixs_prr: string | null,
            /** ixs_pla */
            ixs_pla: string | null,
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

    const deferred = $.Deferred();
    const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
    ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

    let isValid = true;

    var detail = ['Gordic.Adm.WebControls.SeznamAdeProcesRealizaceKniha', { }]

    const options = {
        ID: "AdmAdeProcesRealizaceKniha#",
        ixs_prr: opt ? opt.ixs_prr : undefined,
        ixs_pla: opt ? opt.ixs_pla : undefined,
    };

    if (isValid) {
        //RC 32131033 : Detail
        Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
    } else {
        deferred.reject();
    }
    return deferred.promise();
  }

}
